<template>
  <v-item-group
    @update:modelValue="onSelected"
    v-model="selectedIndexes"
    multiple
    mandatory
  >
    <v-row class="pa-0 ma-0">
      <v-col
        v-for="(type, index) in data.items"
        :key="type.id"
        cols="12"
        md="4"
        lg="4"
        sm="6"
      >
        <v-item v-slot="{ toggle }">
          <v-card
            :color="selectedIndexes.includes(index) ? 'primary' : ''"
            class="d-flex align-start"
            height="160"
            @click="toggle"
          >
            <v-scroll-y-transition hide-on-leave leave-absolute>
              <!-- {{ 
                $refs[`input` + type.id]?.[0]?.hasError?.()
              }} -->
              <div
                v-if="selectedIndexes.includes(index)"
                :key="type.id"
                class="flex-grow-1 d-flex flex-column justify-center align-center white--text text-center pa-2 full-height"
              >
                <div class="full-width">
                  {{}}
                  <HelpFormInput
                    :ref="`input` + type.id"
                    v-model="type.value"
                    :label="`${type.name} (${type.unit})`"
                    color="white"
                    variant="outlined"
                    class="full-width"
                    :help-text="type.howToUseExample"
                    :hint="type.formulaDescription"
                    dark
                    :rules="[
                      ...rules.valueInput,
                      (v) =>
                        v > type.min ||
                        `Value must be greater than ${type.min}`,
                      (v) =>
                        v < type.max || `Value must be less than ${type.max}`,
                    ]"
                    @click.prevent.stop
                  />
                </div>
              </div>

              <div v-else :key="`info` + type.id" class="full-height">
                <v-card-title>
                  {{ type.name }}
                </v-card-title>

                <!-- <v-img
                  :key="type.id"
                  :src="type.img"
                  :lazy-src="type.img"
                  height="60"
                /> -->

                <v-card-text class="type-description">
                  {{ type.description }}
                </v-card-text>
                <v-card-actions class="card-actions-bottom">
                  <v-btn
                    @click.prevent.stop="() => $emit('onDetails', type)"
                    text
                    border
                  >
                    <template #prepend>
                      <v-icon left>mdi-information</v-icon>
                    </template>

                    Read More
                  </v-btn>
                </v-card-actions>
              </div>
            </v-scroll-y-transition>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</template>
  
  
  
  
  <script>
import HelpFormInput from "@/components/atoms/common/inputs/HelpFormInput.vue";
import { AdKPIAPIInstance } from "../../../api";

export default {
  components: {
    HelpFormInput,
  },
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["next", "onDetails", "update:modelValue"],
  data() {
    return {
      defaults: {},
      selectedIndexes: [],
      data: {
        items: [],
        pagination: {
          page: 1,
          pageSize: 100,
        },
      },
      rules: {
        valueInput: [
          (v) => !!v || "Value is required",
          (v) => (v && v > 0) || "Value must be greater than 0",
          (v) => /^[0-9]+$/.test(v) || "Height must be a number",
        ],
      },
    };
  },
  computed: {},
  watch: {
    "modelValue.predictionResult": {
      handler(newValue) {
        if (!newValue) return;
        this.defaults = newValue.target;
        this.setDefaults();
      },
      immediate: true,
    },
  },
  created() {
    this.getList();
  },
  methods: {
    setDefaults() {
      const impressionsKPIIndex = this.data.items.findIndex(
        (item) => item.code === "IMPRESSIONS"
      );
      const clicksKPIIndex = this.data.items.findIndex(
        (item) => item.code === "CLICKS"
      );
      const conversionsKPIIndex = this.data.items.findIndex(
        (item) => item.code === "CONVERSIONS"
      );

      console.log(
        "impressionsKPIIndex",
        impressionsKPIIndex,
        "clicksKPIIndex",
        clicksKPIIndex,
        "conversionsKPIIndex",
        conversionsKPIIndex
      );

      if (impressionsKPIIndex !== -1 && this.defaults.impressions) {
        this.data.items[impressionsKPIIndex].value = this.defaults.impressions;
        this.selectedIndexes.push(impressionsKPIIndex);
      }
      if (clicksKPIIndex !== 1 && this.defaults.clicks) {
        this.data.items[clicksKPIIndex].value = this.defaults.clicks;
        this.selectedIndexes.push(clicksKPIIndex);
      }
      if (conversionsKPIIndex !== 1 && this.defaults.conversions) {
        this.data.items[conversionsKPIIndex].value = this.defaults.conversions;
        this.selectedIndexes.push(conversionsKPIIndex);
      }
    },

    async getList() {
      const { items, pagination } = await AdKPIAPIInstance.list(
        this.data.pagination
      );

      this.data.items = items;
      this.data.pagination = pagination;

      this.setDefaults();
    },
    onSelected(value) {
      this.selectedIndexes = value;

      this.$emit("update:modelValue", {
        ...this.modelValue,
        goal: this.selectedIndexes.reduce((acc, index) => {
          acc[this.data.items[index].code] = this.data.items[index].value;
          return acc;
        }, {}),
      });
    },
  },
};
</script>